/** Review step lists per artifact type and action type. */

export const EMAIL_STEPS = [
  "EmailTemplateSelection",
  "EmailPersonalization",
] as const;

export const POST_STEPS = ["PostReview"] as const;

export const MONITOR_STEPS = ["MonitorCondition", "MonitorResponse"] as const;

export type EmailStep = (typeof EMAIL_STEPS)[number];
export type PostStep = (typeof POST_STEPS)[number];
export type MonitorStep = (typeof MONITOR_STEPS)[number];

export function stepsForArtifact(artifactType: string): readonly string[] {
  switch (artifactType) {
    case "email_html":
    case "email_plaintext":
      return EMAIL_STEPS;
    case "instagram_post":
      return POST_STEPS;
    default:
      return ["GenericReview"];
  }
}

export function stepsForAction(actionType: string): readonly string[] {
  switch (actionType) {
    case "monitor_instagram_comments_and_reply":
      return MONITOR_STEPS;
    default:
      return ["GenericActionConfig"];
  }
}
